import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';
import PopupActions from '../../../actions/PopupActions';

import { endPoints as EndPoints } from '../../../constants/PosCartConstants';

import Price from '../../form/Price.react';
import AjaxPromises from '../../../utils/AjaxPromises';

class CartDetails extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            cart    : false
        }
    }

    componentDidMount() {
        var self = this;


        var formData = UserStore.getApiData();

        formData.guest_id = self.props.guest.Guest_id;
        
        AjaxPromises.POST(EndPoints.LOAD_CART_DETAILS,
            formData).then(res => {
                if (res.Result) {
                    self.setState({ cart : res.Data });
                }
            }
        );
    }

    render() {
        var cart = this.state.cart;

        return (
            <div className='popup__content cart-details'>
                <div className='popup-header'>
                Cart Details

                <div
                        className='popup-close'
                        onClick={() => { PopupActions.close(); }}>

                        <i className="fa fa-times" aria-hidden="true" />
                    </div>
                </div>
                <div className='cart-details__container'>
                    <table className='table-1'>
                        <thead>
                            <tr>
                                <th>Serial No</th>
                                <th>Description</th>
                                <th>Cost</th>
                                <th>Cannabis Product</th>
                                <th>Discount</th>
                                <th>Reason</th>
                                <th>Grams</th>
                                <th>Equivalent</th>
                            </tr>
                        </thead>
                        <tbody>
                            { cart && cart.map((item, i) => {
                                return (
                                    <tr key={item.OrderNo}>
                                        <td className='txt-right'>{item.SerialNo}</td>
                                        <td>{item.Product}</td>
                                        <td className='txt-right'><Price price={item.TotalCost} /></td>
                                        <td className='txt-center'>{item.CannbisProduct}</td>
                                        <td className='txt-right'><Price price={item.DiscountAmt} /></td>
                                        <td>{item.DiscountReason}</td>
                                        <td className='txt-right'>{item.Grams}g</td>
                                        <td className='txt-right'>{item.Equivalent}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default CartDetails;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/sidebar/CartDetails.react.jsx